
const gradeKCalibrationManifest = [
  {
  activityType: "dyslexia",
  type: "dyslexia",
  locale: "en-us",
  sequence: "CONTINUE",
  status: "ASSIGNED",
  storyId: '4583c203-8de8-403b-96b4-8c73e6ce9a70',
  activity: [ ],
  tags: ["NO_QA","NO_EDM","NO_SCALING"],
  isCalibration: true
  },
  {
  activityType: "listeningComprehension",
  type: "listeningComprehension",
  locale: "en-us",
  sequence: "CONTINUE",
  status: "ASSIGNED",
  storyId: 'b3c90f8e-8e87-45d3-ac88-98d8b3433dbc',
  activity: [ ],
  tags: ["NO_QA","NO_EDM","NO_SCALING"],
  isCalibration: true
  }
];
const grade1CalibrationManifest = [
  {
  activityType: "dyslexia",
  type: "dyslexia",
  locale: "en-us",
  sequence: "CONTINUE",
  status: "ASSIGNED",
  storyId: '7512e918-8277-4ede-8a6e-9841a8245f1e',
  activity: [ ],
  tags: ["NO_QA","NO_EDM","NO_SCALING"],
  isCalibration: true
  },
  {
  activityType: "listeningComprehension",
  type: "listeningComprehension",
  locale: "en-us",
  sequence: "CONTINUE",
  status: "ASSIGNED",
  storyId: 'de19de15-2093-43bc-9dff-7dbe88c58b1f',
  activity: [ ],
  tags: ["NO_QA","NO_EDM","NO_SCALING"],
  isCalibration: true
  },
  {
    activityType: "assessment",
    type: "assessment",
    locale: "en-us",
    sequence: "CONTINUE",
    status: "ASSIGNED",
    storyId: 'a5ab5090-a328-11ec-b65b-bdd8d1052980',
    activity: [ ],
    tags: ["NO_QA","NO_EDM","NO_SCALING"],
    isCalibration: true
  },
  {
    activityType: "readingComprehension",
    type: "readingComprehension",
    locale: "en-us",
    sequence: "CONTINUE",
    status: "ASSIGNED",
    storyId: '78355b8b-303a-432d-ae30-536d885ac57e',
    activity: [ ],
    tags: ["NO_QA","NO_EDM","NO_SCALING"],
    isCalibration: true
  },
];
const grade2CalibrationManifest = [
  {
  activityType: "dyslexia",
  type: "dyslexia",
  locale: "en-us",
  sequence: "CONTINUE",
  status: "ASSIGNED",
  storyId: '6c22fbf5-984f-4f64-a78e-5be66ad31fa9',
  activity: [ ],
  tags: ["NO_QA","NO_EDM","NO_SCALING"],
  isCalibration: true
  },
  {
  activityType: "listeningComprehension",
  type: "listeningComprehension",
  locale: "en-us",
  sequence: "CONTINUE",
  status: "ASSIGNED",
  storyId: '93e214fd-3437-47e8-a7f4-a4646e7cf2bc',
  activity: [ ],
  tags: ["NO_QA","NO_EDM","NO_SCALING"],
  isCalibration: true
  },
  {
    activityType: "assessment",
    type: "assessment",
    locale: "en-us",
    sequence: "CONTINUE",
    status: "ASSIGNED",
    storyId: 'd7d55590-a326-11ec-b65b-bdd8d1052980',
    activity: [ ],
    tags: ["NO_QA","NO_EDM","NO_SCALING"],
    isCalibration: true
  },
  {
    activityType: "readingComprehension",
    type: "readingComprehension",
    locale: "en-us",
    sequence: "CONTINUE",
    status: "ASSIGNED",
    storyId: '0eded710-1d3f-4e91-90ea-99aae5d8ef86',
    activity: [ ],
    tags: ["NO_QA","NO_EDM","NO_SCALING"],
    isCalibration: true
  },
];
const grade3CalibrationManifest = [
  {
  activityType: "dyslexia",
  type: "dyslexia",
  locale: "en-us",
  sequence: "CONTINUE",
  status: "ASSIGNED",
  storyId: '7c8f83e6-2ab6-44af-9d85-f6be55777044',
  activity: [ ],
  tags: ["NO_QA","NO_EDM","NO_SCALING"],
  isCalibration: true
  },
  {
    activityType: "assessment",
    type: "assessment",
    locale: "en-us",
    sequence: "CONTINUE",
    status: "ASSIGNED",
    storyId: '9108c690-a32d-11ec-b65b-bdd8d1052980',
    activity: [ ],
    tags: ["NO_QA","NO_EDM","NO_SCALING"],
    isCalibration: true
  },
  {
    activityType: "readingComprehension",
    type: "readingComprehension",
    locale: "en-us",
    sequence: "CONTINUE",
    status: "ASSIGNED",
    storyId: '80a7f7f8-ca96-4ec7-b925-8baba0f6edaf',
    activity: [ ],
    tags: ["NO_QA","NO_EDM","NO_SCALING"],
    isCalibration: true
  },
];

function selectCalibrationManifest(grade) {
  switch (grade) {
    case 0: return gradeKCalibrationManifest;
    case 1: return grade1CalibrationManifest;
    case 2: return grade2CalibrationManifest;
    case 3: return grade3CalibrationManifest;
    default: return null;
  }
}

export function getCalibrationAssignment(grade,assignment){
  //Don't transform the assignment if it's outside the range of grades we have
  const calibrationManifest = selectCalibrationManifest(grade);
  if (!assignment || !calibrationManifest) return assignment;

  //Create the manifest for the calibration assignment
  let newAssignment = JSON.parse(JSON.stringify(assignment))
  newAssignment.manifest = calibrationManifest;
  newAssignment.manifest.forEach((activity)=>{
    const assignmentActivity = assignment.manifest.find((a)=>a.type === activity.type);
    activity.status = assignmentActivity ? assignmentActivity.status : "ASSIGNED";
  });
  return newAssignment;
}

export function getScreenerOverrides(grade) {
  const calibrationManifest = selectCalibrationManifest(grade);
  if (!calibrationManifest) return {};

  // Walk the calibration manifest and return the screener overrides
  let overrides = {};
  calibrationManifest.forEach((activity) => {
    overrides[activity.type] = activity.storyId;
  });
  return overrides;
}